// @ts-check

import BaseModel from "@kaspernj/api-maker/build/base-model.js"
import Collection from "@kaspernj/api-maker/build/collection.js"
import Answer from "./answer.js"
import Element from "./element.js"
import Survey from "./survey.js"
import Team from "./team.js"
import UserStep from "./user-step.js"

const modelClassData = {
  "attributes": {
    "admin_score": {
      "column": {
        "default": null,
        "name": "admin_score",
        "null": true,
        "type": "integer"
      },
      "name": "admin_score",
      "selected_by_default": null,
      "translated": null
    },
    "elaboration": {
      "column": {
        "default": null,
        "name": "elaboration",
        "null": true,
        "type": "text"
      },
      "name": "elaboration",
      "selected_by_default": null,
      "translated": null
    },
    "element_id": {
      "column": {
        "default": null,
        "name": "element_id",
        "null": true,
        "type": "uuid"
      },
      "name": "element_id",
      "selected_by_default": null,
      "translated": null
    },
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      },
      "name": "id",
      "selected_by_default": null,
      "translated": null
    },
    "is_question": {
      "column": null,
      "name": "is_question",
      "selected_by_default": null,
      "translated": null
    },
    "score": {
      "column": {
        "default": 0,
        "name": "score",
        "null": true,
        "type": "integer"
      },
      "name": "score",
      "selected_by_default": null,
      "translated": null
    },
    "total_score": {
      "column": {
        "default": 0,
        "name": "total_score",
        "null": false,
        "type": "integer"
      },
      "name": "total_score",
      "selected_by_default": null,
      "translated": null
    }
  },
  "className": "UserElement",
  "collectionKey": "user_elements",
  "collectionName": "user_elements",
  "i18nKey": "user_element",
  "camelizedLower": "userElement",
  "name": "UserElement",
  "nameDasherized": "user-element",
  "pluralName": "user_elements",
  "ransackable_associations": [
    {
      "className": "Activity",
      "collectionName": "activities",
      "foreignKey": "activity_id",
      "name": "activity",
      "macro": "has_one",
      "resource_name": "Activity",
      "through": "team"
    },
    {
      "className": "Answer",
      "collectionName": "answers",
      "foreignKey": "user_element_id",
      "name": "answers",
      "macro": "has_many",
      "resource_name": "Answer",
      "through": null
    },
    {
      "className": "Element",
      "collectionName": "elements",
      "foreignKey": "element_id",
      "name": "element",
      "macro": "belongs_to",
      "resource_name": "Element",
      "through": null
    },
    {
      "className": "ElementFeedback",
      "collectionName": "element_feedbacks",
      "foreignKey": "element_id",
      "name": "element_feedbacks",
      "macro": "has_many",
      "resource_name": "ElementFeedback",
      "through": "element"
    },
    {
      "className": "Log",
      "collectionName": "logs",
      "foreignKey": "trackable_id",
      "name": "logs",
      "macro": "has_many",
      "resource_name": "Log",
      "through": null
    },
    {
      "className": "Option",
      "collectionName": "options",
      "foreignKey": "option_id",
      "name": "options",
      "macro": "has_many",
      "resource_name": "Option",
      "through": "answers"
    },
    {
      "className": "Step",
      "collectionName": "steps",
      "foreignKey": "step_id",
      "name": "step",
      "macro": "has_one",
      "resource_name": "Step",
      "through": "element"
    },
    {
      "className": "Survey",
      "collectionName": "surveys",
      "foreignKey": "survey_id",
      "name": "survey",
      "macro": "has_one",
      "resource_name": "Survey",
      "through": "element"
    },
    {
      "className": "Tagging",
      "collectionName": "taggings",
      "foreignKey": "resource_id",
      "name": "taggings",
      "macro": "has_many",
      "resource_name": "Tagging",
      "through": null
    },
    {
      "className": "Tag",
      "collectionName": "tags",
      "foreignKey": "tag_id",
      "name": "tags",
      "macro": "has_many",
      "resource_name": "Tag",
      "through": "taggings"
    },
    {
      "className": "Team",
      "collectionName": "teams",
      "foreignKey": "team_id",
      "name": "team",
      "macro": "has_one",
      "resource_name": "Team",
      "through": "team_survey"
    },
    {
      "className": "TeamSurvey",
      "collectionName": "team_surveys",
      "foreignKey": "team_survey_id",
      "name": "team_survey",
      "macro": "has_one",
      "resource_name": "TeamSurvey",
      "through": "user_step"
    },
    {
      "className": "TeamUser",
      "collectionName": "team_users",
      "foreignKey": "team_id",
      "name": "team_users",
      "macro": "has_many",
      "resource_name": "TeamUser",
      "through": "team"
    },
    {
      "className": "Tenant",
      "collectionName": "tenants",
      "foreignKey": "tenant_id",
      "name": "tenant",
      "macro": "belongs_to",
      "resource_name": "Tenant",
      "through": null
    },
    {
      "className": "UserStep",
      "collectionName": "user_steps",
      "foreignKey": "user_step_id",
      "name": "user_step",
      "macro": "belongs_to",
      "resource_name": "UserStep",
      "through": null
    },
    {
      "className": "WorkerPlugins::WorkplaceLink",
      "collectionName": "workplace_links",
      "foreignKey": "resource_id",
      "name": "workplace_links",
      "macro": "has_many",
      "resource_name": "WorkplaceLink",
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "admin_score",
      "column": {
        "default": null,
        "name": "admin_score",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "elaboration",
      "column": {
        "default": null,
        "name": "elaboration",
        "null": true,
        "type": "text"
      }
    },
    {
      "name": "element_id",
      "column": {
        "default": null,
        "name": "element_id",
        "null": true,
        "type": "uuid"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "id_string",
      "column": null
    },
    {
      "name": "old_element_id",
      "column": {
        "default": null,
        "name": "old_element_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "old_id",
      "column": {
        "default": null,
        "name": "old_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "old_user_step_id",
      "column": {
        "default": null,
        "name": "old_user_step_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "score",
      "column": {
        "default": 0,
        "name": "score",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "tenant_id",
      "column": {
        "default": null,
        "name": "tenant_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "total_score",
      "column": {
        "default": 0,
        "name": "total_score",
        "null": false,
        "type": "integer"
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "user_step_id",
      "column": {
        "default": null,
        "name": "user_step_id",
        "null": true,
        "type": "uuid"
      }
    }
  ],
  "ransackable_scopes": [
    {
      "name": "in_current_workplace"
    },
    {
      "name": "order_by_position"
    },
    {
      "name": "soft_deleted_filter"
    },
    {
      "name": "sort_by_in_current_workplace_asc"
    },
    {
      "name": "sort_by_in_current_workplace_desc"
    }
  ],
  "relationships": [
    {
      "className": "Answer",
      "collectionName": "answers",
      "foreignKey": "user_element_id",
      "name": "answers",
      "macro": "has_many",
      "resource_name": "Answer",
      "through": null
    },
    {
      "className": "Element",
      "collectionName": "elements",
      "foreignKey": "element_id",
      "name": "element",
      "macro": "belongs_to",
      "resource_name": "Element",
      "through": null
    },
    {
      "className": "Survey",
      "collectionName": "surveys",
      "foreignKey": "survey_id",
      "name": "survey",
      "macro": "has_one",
      "resource_name": "Survey",
      "through": "element"
    },
    {
      "className": "Team",
      "collectionName": "teams",
      "foreignKey": "team_id",
      "name": "team",
      "macro": "has_one",
      "resource_name": "Team",
      "through": "team_survey"
    },
    {
      "className": "UserStep",
      "collectionName": "user_steps",
      "foreignKey": "user_step_id",
      "name": "user_step",
      "macro": "belongs_to",
      "resource_name": "UserStep",
      "through": null
    }
  ],
  "paramKey": "user_element",
  "primaryKey": "id"
}

/** Frontend model for UserElement. */
export default class UserElement extends BaseModel {
  /** @returns {typeof modelClassData} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {number | null} */
  adminScore() {
    return this.readAttributeUnderscore("admin_score")
  }

  /** @returns {boolean} */
  hasAdminScore() {
    const value = this.adminScore()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  elaboration() {
    return this.readAttributeUnderscore("elaboration")
  }

  /** @returns {boolean} */
  hasElaboration() {
    const value = this.elaboration()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  elementId() {
    return this.readAttributeUnderscore("element_id")
  }

  /** @returns {boolean} */
  hasElementId() {
    const value = this.elementId()

    return this._isPresent(value)
  }

  /** @returns {string} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {any} */
  isQuestion() {
    return this.readAttributeUnderscore("is_question")
  }

  /** @returns {boolean} */
  hasIsQuestion() {
    const value = this.isQuestion()

    return this._isPresent(value)
  }

  /** @returns {number | null} */
  score() {
    return this.readAttributeUnderscore("score")
  }

  /** @returns {boolean} */
  hasScore() {
    const value = this.score()

    return this._isPresent(value)
  }

  /** @returns {number} */
  totalScore() {
    return this.readAttributeUnderscore("total_score")
  }

  /** @returns {boolean} */
  hasTotalScore() {
    const value = this.totalScore()

    return this._isPresent(value)
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  droppedOptionOnOption(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (this._callMemberCommand(
      {
        args,
        command: "dropped_option_on_option",
        primaryKey: this.primaryKey(),
        collectionName: "user_elements",
        type: "member"
      },
      commandArgs
    ))
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./answer.js").default>} */
  answers() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["user_element_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "answers",
        model: this,
        modelClass: Answer
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./answer.js").default>>} */
  loadAnswers() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["user_element_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "answers",
        model: this,
        modelClass: Answer
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./answer.js").default>>} */
  ensureAnswersLoaded() {
    return this.ensureAssociationLoaded("answers")
  }

  /** @returns {import("./element.js").default | null} */
  element() {
    return this._readBelongsToReflection({modelClass: Element, reflectionName: "element"})
  }

  /** @returns {Promise<import("./element.js").default | null>} */
  loadElement() {
    if (!("elementId" in this)) throw new Error("Foreign key method wasn't defined: elementId")

    const id = this.elementId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "element",
        model: this,
        modelClass: Element
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./element.js").default | null>} */
  ensureElementLoaded() {
    return this.ensureAssociationLoaded("element")
  }

  /** @returns {import("./survey.js").default | null} */
  survey() {
    return this._readHasOneReflection({modelClass: Survey, reflectionName: "survey"})
  }

  /** @returns {Promise<import("./survey.js").default | null>} */
  loadSurvey() {
    if (!("id" in this)) throw new Error("Primary key method wasn't defined: id")

    const id = this.id()

    return this._loadHasOneReflection(
      {
        reflectionName: "survey",
        model: this,
        modelClass: Survey
      },
      {
        params: {
          through: {
            model: "UserElement",
            id,
            reflection: "survey"
          }
        }
      }
    )
  }

  /** @returns {Promise<import("./survey.js").default | null>} */
  ensureSurveyLoaded() {
    return this.ensureAssociationLoaded("survey")
  }

  /** @returns {import("./team.js").default | null} */
  team() {
    return this._readHasOneReflection({modelClass: Team, reflectionName: "team"})
  }

  /** @returns {Promise<import("./team.js").default | null>} */
  loadTeam() {
    if (!("id" in this)) throw new Error("Primary key method wasn't defined: id")

    const id = this.id()

    return this._loadHasOneReflection(
      {
        reflectionName: "team",
        model: this,
        modelClass: Team
      },
      {
        params: {
          through: {
            model: "UserElement",
            id,
            reflection: "team"
          }
        }
      }
    )
  }

  /** @returns {Promise<import("./team.js").default | null>} */
  ensureTeamLoaded() {
    return this.ensureAssociationLoaded("team")
  }

  /** @returns {import("./user-step.js").default | null} */
  userStep() {
    return this._readBelongsToReflection({modelClass: UserStep, reflectionName: "user_step"})
  }

  /** @returns {Promise<import("./user-step.js").default | null>} */
  loadUserStep() {
    if (!("userStepId" in this)) throw new Error("Foreign key method wasn't defined: userStepId")

    const id = this.userStepId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "user_step",
        model: this,
        modelClass: UserStep
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./user-step.js").default | null>} */
  ensureUserStepLoaded() {
    return this.ensureAssociationLoaded("user_step")
  }
}
